<template>
  <div>
    <div class="activity">
      <!-- 左侧 活动信息 -->
      <div class="activity_message">
        <!-- 活动详情 -->
        <div class="activity_particulars">
          <div class="particulars_title">
            <span
              class="particulars"
              :class="{
                weight: weight == 0
              }"
              @click="weight = 0"
              >活动详情</span
            >
            <span
              class="msg"
              :class="{
                weight: weight == 1
              }"
              @click="weight = 1"
              >{{ $t('message.home.prize_information') }}</span
            >
          </div>
        </div>

        <div v-show="weight == 0">
          <div class="particulars_text" v-html="dataList.activeDetails"></div>

          <!-- 关联榜单 -->
          <div class="activity_relevancy" v-if="selectByIdList.length != 0">
            <div class="relevancy_title">关联榜单</div>
            <div class="relevancy_text">
              <div class="relevancy_text_item" v-for="(item, index) in selectByIdList" :key="index">
                <div class="label">
                  <span>《{{ item.listTitle }}》</span>
                </div>
                <div class="to_vote" @click="clickTpVote(item.id)">
                  <span>去投票</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 活动赛区 -->
          <div class="activity_area">
            <div class="area_title">活动赛区</div>
            <div class="area_text">
              <img
                :src="item"
                alt=""
                v-for="(item, index) in dataList.activeDivisionNameResultList"
                :key="index"
              />
            </div>
          </div>

          <!-- 投稿规则 -->
          <div class="activity_regulation">
            <div class="regulation_title">投稿规则</div>
            <div class="regulation_text">
              <p>一、作品要求</p>
              <p>
                （1）彩色、黑白不限，单幅、组照均可，组照图片数量应在4-12幅之间。投稿作品电子文件须为JPG格式，作品长边像素不低于3000，图片大小1-16MB。
              </p>
              <p>
                （2）照片须保留其原始信息，对于不能提供原始照片信息的图片，视为无效作品。不得对投稿作品原始影像删改、添加、技术合成等。可适当调整作品亮度、对比度、色彩饱和度及构图剪裁等必要的后期处理。作品描述中须注明拍摄时间、地点、拍摄内容、学校或机构名称等。
              </p>
              <p>二、权责说明</p>
              <p>
                1.投稿作品不得侵犯他人的著作权、肖像权、名誉权、隐私权。若有第三方对作品中的人、建筑或其他事物提出权利方面的声明或不满，投稿者应对作品引发或可能引发的法律事务承担全部责任。
              </p>
              <p>
                2.对于足以妨害公序良俗的作品及行为，一经发现将取消入选资格。“妨害公序良俗的作品及行为”包括但不限于可能严重误导公众认知、具有欺诈性质等一切违反法律、道德、公共秩序或善良风俗的情形。
              </p>
              <p>
                3.本次活动不收取任何费用，不设退稿。投稿作品仍由作者保留对作品的各项权利，活动组织方和征稿平台拥有作品在本次征集活动宣传范围内非商业用途使用权。著作权归作者所有，投稿作品将授予主办方及关联单位机构用于推广宣传活动，通过各种渠道（包括但不限于网络、影像发布或其他媒体、线下展示推广等活动）使用作品，使用时将保留作者署名权，使用时间三年，使用地域不受限制，允许主办方对（摄影类、科创类编程）作品进行修改和裁切等。
              </p>

              <p>
                4.参赛者一旦上传作品，即视为同意并遵守以上规则。凡不符合征稿要求的作品，一律取消参赛资格。
              </p>

              <p>5.本次活动最终解释权归主办方所有。</p>
              <p>三、注意事项</p>
              <p>
                1．参评者注册与填写信息须真实有效，并保持通讯畅通。主办方将通过电话和邮箱两种方式与入围作品参评者联系，要求参评者在指定日期内提供相关资料，逾期者视为自愿放弃。
              </p>
              <p>
                2．因奖品获得者未能提供准确的信息资料而导致未能收到相应稿酬、获奖证书的，责任由获奖者本人负责。
              </p>
            </div>
          </div>
        </div>

        <!--  奖项信息 -->
        <div class="prize_information" v-show="weight == 1">
          <div v-html="dataList.prizeSet"></div>
        </div>
      </div>

      <!-- 右侧 其他信息 -->
      <div class="other_information">
        <!-- 主办方信息 -->
        <div class="main_inform">
          <div class="main_inform_title">
            <div class="label"></div>
            <span class="title">主办方信息</span>
          </div>

          <div class="main_inform_text">
            <div class="undertake" v-for="(item, index) in dataList.guidanceList" :key="index">
              {{ item }}
            </div>
            <!-- <div class="coordinate">{{ dataList.assistUnit }}</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDetailActivityWeb } from '@/api/activity'
import { selectById } from '@/api/common.js'
import { getCookie, setCookie, clearCookie } from '@/utils/cookie'
import { Toast } from 'vant'
export default {
  components: {},
  data() {
    return {
      // 活动简介数据
      dataList: {},
      // 榜单数据
      selectByIdList: [],
      // 字体加粗
      weight: 0
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  watch: {},
  created() {
    this.search()
    this.getSelectById()
  },
  methods: {
    clickTpVote(id) {
      console.log('去投票')
      let token = getCookie('token')
      if (token) {
        this.$router.push({
          name: 'Listvote',
          query: { id }
        })
      } else {
        Toast.fail(this.$t('message.my.logged'))
        setTimeout(() => {
          this.$router.push({
            name: 'Login'
          })
        }, 1000)
      }
    },
    async search() {
      const { data: res } = await getDetailActivityWeb({
        id: this.id,
        language:
          sessionStorage.getItem('lang') == undefined ? 'zhcn' : sessionStorage.getItem('lang'),
        divisionName:
          sessionStorage.getItem('divisionName') == '' ? '' : sessionStorage.getItem('divisionName')
      })
      // console.log(res.data)
      if (res.resultCode == 200) {
        this.dataList = res.data
      }
    },
    async getSelectById() {
      const { data: res } = await selectById({ id: this.id })
      if (res.resultCode == 200) {
        if (res.data.h5ListSlideshowList != null) {
          this.selectByIdList = res.data.h5ListSlideshowList
        }
      }
    }
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.activity {
  width: 100%;
  display: flex;

  .activity_message {
    padding-left: 142px;
    flex: 1;
    .particulars_text {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      text-indent: 2em;
      line-height: 22.75px;
      padding-bottom: 19px;
      box-sizing: border-box;
    }
    .activity_particulars {
      .particulars_title {
        height: 77px;
        line-height: 77px;
        color: #151515;
        font-size: 20px;
        .particulars {
          cursor: pointer;
        }

        .msg {
          margin-left: 30px;
          font-weight: 400;
          cursor: pointer;
        }

        .weight {
          font-weight: 600;
        }
      }
      // .particulars_text {
      //   font-size: 14px;
      //   font-weight: 400;
      //   color: #666666;
      //   text-indent: 2em;
      //   line-height: 22.75px;
      //   padding-bottom: 19px;
      //   box-sizing: border-box;
      // }
    }

    .prize_information {
      font-size: 14px;
      color: #666666;
    }

    .activity_relevancy {
      padding-bottom: 25px;
      .relevancy_title {
        line-height: 28px;
        color: #151515;
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 14px;
      }
      .relevancy_text {
        .relevancy_text_item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-radius: 16px;
          background-color: #f2f6fc;
          height: 53px;
          color: #3562ff;
          font-size: 16px;
          margin-bottom: 5px;

          .label {
            height: 100%;
            display: flex;
            align-items: center;
            margin-left: 22px;
            font-weight: 500;
            img {
              width: 16px;
              height: 16px;
              margin-right: 10px;
            }
          }
          .to_vote {
            margin-right: 37px;
            cursor: pointer;
            height: 100%;
            display: flex;
            align-items: center;
            img {
              width: 22px;
              height: 22px;
              margin-left: 6px;
            }
          }
        }
      }
    }

    .activity_area {
      .area_title {
        color: #151515;
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        margin-bottom: 11px;
      }
      .area_text {
        margin-bottom: 30px;
        img {
          margin-right: 25px;
          width: 40px;
          height: 40px;
        }
      }
    }

    .activity_regulation {
      .regulation_title {
        color: #151515;
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        margin-bottom: 9px;
      }
      .regulation_text {
        font-size: 14px;
        font-weight: 400;
        line-height: 22.75px;
        color: #666666;
      }
    }
  }

  .other_information {
    // width: 367px;
    width: 19.11%;
    box-sizing: border-box;
    padding: 35px 41px 0 30px;

    .main_inform_title {
      display: flex;
      align-items: center;
      margin-bottom: 11px;
      .label {
        width: 4px;
        height: 17px;
        background-color: #3562ff;
        border-radius: 2px;
        margin-right: 8px;
      }
      .title {
        color: #151515;
        font-size: 16px;
        font-weight: 500;
      }
    }
    .main_inform_text {
      color: #666666;
      font-size: 14px;
      font-weight: 400;
      line-height: 24.43px;
      // .undertake {
      // }
      .coordinate {
        margin-top: 3px;
      }
    }
  }
}
</style>
